<template>
  <div class="container">
    <p>KABI China（以下简称“应用程序”）由费森尤斯卡比（中国）投资有限公司（与北京费森尤斯卡比医药有限公司、费森尤斯卡比华瑞制药有限公司一起，简称“费森尤斯卡比”运营，仅提供给公司员工使用的移动应用程序。本应用严格遵循 [费森尤斯卡比] 隐私政策，致力于在保障信息安全的前提下，提供高效、智能的办公服务。</p>
  </div>
</template>

<script>
export default {
  components: {},
  
  data() {
    return {
      
    };
  },
  computed: {
  },
  created() {
    window.document.title = this.$t('message.PrivacyPolicy');
  },
  beforeCreate() {
      
  },
  beforeDestroy() {
  },
  mounted() {
  },
  methods: {
    
    
  },
};
</script>

<style scoped>
.container {
    max-width: 800px;
    margin: 25px auto;
    padding: 20px;
}
p{
    margin-bottom: 15px;
    text-indent: 2em;
    font-size: 15px;
    line-height: 30px;
    color: #495057;
}
</style>
